import React, { useContext, useEffect } from 'react';
import _ from 'lodash';

import { WorldCupView } from '@lbs/sportsbook';
import { Swarm } from '@lbs/swarm-client';

import { initSportsbookListeners } from '@app/dev/services/sportsbookListeners';
import { PreferencesContext } from '@common/contexts/preferences';
import { SelectionsContext } from '@common/contexts/selections';
import { useTranslation } from '@common/hooks/translation';
import OddConverter from '@common/helpers/oddConverter';
import Helpers from '@common/helpers/helperFunctions';
import Config from '@app/dev/config/main';

import './style.scss';

initSportsbookListeners();

const getSportsbookConfig = _.once(() => ({
  ...Config.sportsbook,
  odd: Config.odd,
  env: Config.env,
  enableStatisticsIcon: Config.sportsbook.enableStatisticsIcon && !Helpers.isSecondScreenAvailable(Config),
  enableVirtualStreams: Config.sportsbook.enableVirtualStreams && !Helpers.isSecondScreenAvailable(Config),
  enableBannerAnimation: Config.sportsbook.enableBannerAnimation && !Helpers.isSecondScreenAvailable(Config),
}));

// Thin terminal shell around `@lbs/sportsbook`'s WorldCupView. The view +
// sub-nav + sidebar + match list + details all live in the sportsbook
// package now; here we only wire the host's config / selections /
// translations and toggle the `worldcup-active` class on the wrapper so
// the header restyle still applies.
const WorldCup = () => {
  const sportsbookConfig = getSportsbookConfig();
  const t = useTranslation();
  const [{ lang, oddsFormat }] = useContext(PreferencesContext);
  const [selections, setSelections] = useContext(SelectionsContext);

  const handleSetSelections = (newEvents) => {
    if (selections.placeBetLoading) return;
    setSelections({ ...selections, ...newEvents });
  };

  useEffect(() => {
    const wrapper = document.querySelector('.terminal-wrapper');
    if (wrapper) wrapper.classList.add('worldcup-active');
    return () => {
      if (wrapper) wrapper.classList.remove('worldcup-active');
    };
  }, []);

  return (
    <WorldCupView
      config={sportsbookConfig}
      language={lang}
      oddsFormat={oddsFormat}
      translate={t}
      swarmInstance={Swarm.getInstance()}
      events={selections.events}
      setEvents={handleSetSelections}
      odd={_.partial(OddConverter, Config)}
      routePrefix="/worldcup"
    />
  );
};

export default WorldCup;
